import { render } from "./opening.vue?vue&type=template&id=2a7c5c1e"
import script from "./opening.vue?vue&type=script&lang=js"
export * from "./opening.vue?vue&type=script&lang=js"

import "./opening.vue?vue&type=style&index=0&id=2a7c5c1e&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__